/* QUILTZA ana sayfa: hero slider, Seçkimiz sekmeleri, şeffaf header. Vanilla JS. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero slider ---------- */
  function initHero(root) {
    if (!root || root.dataset.qzReady) return;
    root.dataset.qzReady = 'true';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-qz-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-qz-dot]'));
    var pauseBtn = root.querySelector('[data-qz-pause]');
    var index = 0;
    var timer = null;
    var userPaused = false;
    var hoverPaused = false;
    var delay = parseInt(root.dataset.speed, 10) || 6000;
    var autoplay = root.dataset.autoplay === 'true' && slides.length > 1 && !reduceMotion;

    function go(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === index;
        s.classList.toggle('is-active', on);
        if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); }
        else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
        var v = s.querySelector('video');
        if (v) { try { if (on) v.play(); else v.pause(); } catch (e) {} }
      });
      dots.forEach(function (d, n) { if (n === index) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (autoplay && !userPaused && !hoverPaused && !document.hidden) timer = setInterval(function () { go(index + 1); }, delay);
    }

    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.qzDot, 10)); start(); }); });
    root.addEventListener('keydown', function (e) {
      if (slides.length < 2) return;
      if (e.key === 'ArrowRight') { go(index + 1); start(); }
      if (e.key === 'ArrowLeft') { go(index - 1); start(); }
    });
    root.addEventListener('mouseenter', function () { hoverPaused = true; stop(); });
    root.addEventListener('mouseleave', function () { hoverPaused = false; start(); });
    root.addEventListener('focusin', function () { hoverPaused = true; stop(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { hoverPaused = false; start(); } });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    if (pauseBtn) {
      if (!autoplay) pauseBtn.hidden = true;
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', userPaused ? pauseBtn.dataset.labelPlay : pauseBtn.dataset.labelPause);
        if (userPaused) stop(); else start();
      });
    }
    start();
    initHeaderOverlay(root);
  }

  /* ---------- Şeffaf header (yalnızca hero sayfanın ilk bölümüyse) ---------- */
  function initHeaderOverlay(hero) {
    if (hero.dataset.headerOverlay !== 'true') return;
    var section = hero.closest('.shopify-section');
    var main = document.getElementById('MainContent');
    if (!section || !main || main.firstElementChild !== section) { hero.classList.remove('qz-hero--overlay'); return; }
    var wrapper = document.querySelector('.shopify-section-group-header-group .header-wrapper');
    var headerSection = wrapper && wrapper.closest('.shopify-section');
    if (!headerSection) { hero.classList.remove('qz-hero--overlay'); return; }
    var body = document.body;
    body.classList.toggle('qz-hdr-overlay--light', hero.dataset.headerText !== 'dark');
    function measure() { document.documentElement.style.setProperty('--qz-hdr-h', headerSection.offsetHeight + 'px'); }
    function onScroll() { body.classList.toggle('qz-hdr-overlay', window.scrollY < 20); }
    measure();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(headerSection);
  }

  /* ---------- Seçkimiz sekmeleri ---------- */
  function initTabs(root) {
    if (!root || root.dataset.qzReady) return;
    root.dataset.qzReady = 'true';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-qz-tab]'));
    if (!tabs.length) return;
    function activate(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); activate(next, true); }
      });
    });
    document.addEventListener('shopify:block:select', function (e) {
      var t = root.querySelector('#QzTab-' + e.detail.blockId);
      if (t) activate(t, false);
    });
  }

  function boot() {
    document.querySelectorAll('[data-qz-hero]').forEach(initHero);
    document.querySelectorAll('[data-qz-tabs]').forEach(initTabs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
